<template>
  <div class="-wrapper-column h-center- -height-100 -px-10 -py-10">
    <div class="login-logo-wrap -wrapper-v-center -width-100">
      <img src="/assets/images/logo_header.jpg" alt="Ops Now" />
    </div>
    <div class="login-cont-wrap -wrapper -wrapper-v-h-center">
      <div class="login-wrap -wrapper nowrap-">
        <div class="form-wrap -wrapper -p-10 -font-size-12">
          <h1 class="-h1 -mb-10 -font-size-32 -font-weight-medium -width-100 text-center-">로그인</h1>
          <div class="-label -width-100 -pb-8">
            <div class="-wrapper">
              <p class="-text">아이디</p>
              <p class="-color-blue-1 -ml-1 -mt-1">*</p>
            </div>
            <input type="text" class="-input -width-100" placeholder="아이디 입력" />
          </div>
          <div class="-label -width-100 -pb-8">
            <div class="-wrapper">
              <p class="-text">비밀번호</p>
              <p class="-color-blue-1 -ml-1 -mt-1">*</p>
            </div>
            <input type="password" class="-input -width-100" placeholder="비밀번호 입력" />
            <template v-if="loginError">
              <p class="-description-error">
                아이디 또는 비밀번호가 올바르지 않습니다.
              </p>
              <div class="error-bg-color -p-2 -border-radius-1 -mt-2">
                <p class="error-font-color">
                  {#}회 실패. 고객님의 정보 보호를 위해 로그인 5회 실패 시,
                  <br/>
                  본인 인증 후 비밀번호를 초기화해야 합니다.
                </p>
                </div>
            </template>
          </div>
          <div class="-label -width-100 -pb-2">
            <button class="-btn primary- -width-100" type="submit">
              <span>로그인</span>
            </button>
          </div>
          <div class="-label -width-100 -wrapper -wrapper-between -pb-8 -border-bottom">
            <div class="-wrapper">
              <input type="checkbox" class="-check" id="checkbox" checked>
              <label for="checkbox">
                <em class="-label">아이디 기억하기</em>
              </label>
            </div>
            <a href="#" class="-color-blue-1" @click="onClickResetPassword">비밀번호 초기화</a>
          </div>
          <div class="-wrapper-column -width-100 -pt-8 -pb-4 v-h-center-">
            <h3 class="-wrapper-h-center -width-100 -h3 -font-weight-regular h-center- text-center-">
              로그인이 안되시나요?
              <br />
              문의 사항이 있으시면 서비스 데스크로 문의 주세요.
            </h3>
            <button class="-btn secondary- -mt-4" type="button">
              <span>서비스 데스크</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginResetPasswordPopup from './components/LoginResetPasswordPopup'

export default {
  name: 'login',
  componentName: 'Login',
  data() {
    return {
      loginError: true
    }
  },
  methods: {
    onClickResetPassword(e) {
      this.$popupManager.open(LoginResetPasswordPopup)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/Login.vue